module.exports = __webpack_public_path__ + "static/TronWallet-dc40e5a11209c67dc366f4ebb564d99b.png";